import { createFeature, createReducer } from '@ngrx/store';

import { cancelPreauthDialogReducers } from './cancel-preauth-dialog.reducer';
import { cancelPreauthDialogInitialState } from './cancel-preauth-dialog.state';

export const cancelPreauthDialogFeature = createFeature({
    name: 'cancelPreauthDialog',
    reducer: createReducer(cancelPreauthDialogInitialState, ...cancelPreauthDialogReducers),
});
